/** Blog 页面共用的 APK 下载逻辑（与旧博客页一致） */
export default {
  data() {
    return {
      apk: null,
      from: 'gb',
      filename: 'gb',
    }
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from
    this.filename = this.$global.GetQueryString('filename') || this.filename
    if (this.$global.GetQueryString('from')) {
      this.getAPK()
    } else {
      this.getOfficalApk()
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          this.apk = res.code == 200 ? res.data.apk : process.env.VUE_APP_GBLINK
        })
    },
    getOfficalApk() {
      this.$server
        .getOfficalApk({
          domain: 'gbwhatsapp.chat',
          appName: 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          this.apk = res.code == 200 ? res.data.apk : process.env.VUE_APP_GBLINK
        })
    },
    gotodownload() {
      if (this.apk) this.$global.download(this.apk)
    },
  },
}
